module.exports = __webpack_public_path__ + "img/geofisica_3-4_768.aa8e150d.jpg";